(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSSectorController', SSSectorController);

    SSSectorController.$inject = ['SSSector'];

    function SSSectorController(SSSector) {

        var vm = this;

        vm.sSSectors = [];

        loadAll();

        function loadAll() {
            SSSector.query(function(result) {
                vm.sSSectors = result;
                vm.searchQuery = null;
            });
        }
    }
})();
